import TagManager from "react-gtm-module";

export const initializeTagManager = () => {
  const tagManagerId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || "";

  if (tagManagerId !== "") {
    const tagManagerArgs = {
      gtmId: tagManagerId
    }
   
    TagManager.initialize(tagManagerArgs);
  }
}